import { Section } from '@shared/components/Section';
import { GradeDeCartoes } from '@shared/components/moldes';
import { provas } from '@curso/content/curso';

/**
 * Bloco 2. Responde: por que confiar antes de ler o resto.
 *
 * Primeira edição, então não há depoimento nem foto de turma anterior. No
 * lugar da prova social entra a prova que existe hoje: base, método e postura.
 */
export function ProvaImediata() {
  return (
    <Section id="prova" rotulo="Por que este curso" titulo="Por que esta imersão é diferente">
      <GradeDeCartoes itens={provas} />
    </Section>
  );
}
